//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";
import General from "../../../utils/General";
import iconTimeBlack from "../../../images/icons/icon_time_black.svg";
import iconCaretDownBlack from "../../../images/icons/icon_caret_down_black.svg";
import iconCaretUpBlack from "../../../images/icons/icon_arrow_up_black.svg";
import iconChecklistGreen from "../../../images/icons/icon_circlechecklist_black.svg";
import iconExpBlack from "../../../images/icons/icon_exp_black.svg";
import iconSkpPoint from "../../../images/icons/icon_skp_point.svg";
import iconAloPoint from "../../../images/icons/icon_poin_ap.svg";
import Alodokter from "../../../utils/Alodokter";

import "../../../components/desktop/shared/Modal";
import "../../../components/desktop/ecourse/VideoPlayer/VideoPlayer";
import "../../../components/desktop/shared/GeneralToast";
import { 
    _checkIsUserPassedPostTest, 
    _sponsoreChannelLogo,
    _sponsoreChannelCategory,
    _sponsoreChannelName,
    _isShowSponsoreChannel,
    _iconReferenceShow,
    _iconReferenceHide,
    _isShowReference,
    _isShowReviewedBy,
    _checkSkpTypeOf,
    iterateFieldListName,
    _isVideoUrlAttached,
    _isSkpDetailExpired,
    _sessionStorageSkp,
    _textButtonSkpDetail,
    _checkSkpPoint,
    _checkEmptyData
  } from "../../../utils/skp";
import WebinarAnalytics from "../../../analytics/WebinarAnalytics";
import EcourseAnalytics from "../../../analytics/EcourseAnalytics";
import VideoPlayerAnalytics from "../../../analytics/VideoPlayerAnalytics";

class SkpShow extends PolymerElement {
  static get template() {
    return html`
      <style>
        button {
          font-family: "Lato", sans-serif;
        }
        .text-display1 {
          font-size: 18px;
          font-weight: 700;
          color: #7F7F7F;
          line-height: 24px;
          margin: 0 !important;
          padding: 0 !important;
        }
        .text-display2 {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          margin: 0 !important;
          padding: 0 !important;
          color: #424242;
          margin-right: 16px!important;
        }
        .text-display-sponsorship {
          font-size: 14px;
          line-height: 20px;
          margin: 0 0 0 10px !important;
          padding: 0 !important;
          color: #7F7F7F; 
          margin-right: 16px!important;
        }
        .container {
          display: flex !important;
          flex-direction: column !important;
          margin: 0 auto;
          padding: 26px 2px 60px;
        }
        .row {
          margin-bottom: 5px;
        }
        .container-main {
          display: flex !important;
          align-items: flex-start;
        }
        .content-main-left {
          flex: 2;
        }
        .content-main-right {
          flex: 1;
          margin-left: 15px;
          position: sticky;
        }
        .card-menu {
          display: flex !important;
          flex-direction: column !important;
          border: 1px solid #DADEE4;
          padding: 16px;
          border-radius: 4px;
          margin-bottom: 8px;
        }
        .btn {
          align-items: center;
          justify-content: center;
        }
        .btn-start-test {
          line-height: 24px;
          border: 1px solid #3570D2;
          border-radius: 5px;
          text-align: center;
          display: flex;
          background-color: #3570D2;
          font-size: 18px;
          color: white;
          cursor: pointer;
          font-weight: 700;
          padding: 12px;
        }
        .btn-start-test-expired {
          line-height: 24px;
          border: 1px solid #3570D2;
          border-radius: 5px;
          text-align: center;
          display: flex;
          background-color: #3570D2;
          font-size: 18px;
          color: white;
          font-weight: 700;
          padding: 12px;
          opacity: 0.4;
        }
        .card-info {
          display: flex !important;
          flex-direction: column !important;
          border: 1px solid #3570D2;
          padding: 16px;
          background-color: #E5EFFF
        }
        .content-main-left .content-text {
          margin-top: 12px;
          margin-bottom: 60px !important;
        }
        .text-description {
          font-style: normal;
          font-weight: 700;
          font-size: 24px;
          margin: 0;
          line-height: 32px;
          color: #424242;
        }
        .content-column {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          margin: 10px 0 20px 2px;
        }
        .content-column label {
          display: flex !important;
          align-items: center !important;
        }
        .content-text p {
          line-height: 24px;
          margin: 8px 0px 18px 0px;
          color: #424242;
        }
        .content-text p p a {
          overflow-wrap: anywhere;
        }
        .content-column-sponsorship {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          margin: 20px 0 0 0;
        }
        .content-column-sponsorship label {
          display: flex !important;
          align-items: center !important;
        }
        .content-column-sponsorship img {
          height: 40px;
        }
        hr {
          border: 0;
          height: 0;
          border-top: 1.2px solid rgba(0, 0, 0, 0.1);
          margin: 20px 0 10px 0;
        }
        .container-reference {
          display: flex !important;
          flex-direction: column !important;
          border: 1px solid #D9D9D9;
          padding: 16px;
          border-radius: 4px;
          background: #ECECEC;
          margin-bottom: 8px;
          word-break: break-all;
        }
        .card-reference {
          display: flex;
          justify-content: space-between;
          background: #ECECEC;
          align-items: center;
        }
        .show {
          display: block;
          margin: 0px;
          background: #ECECEC;
          width: 615px;
          padding: 0 10px 0 0;
          color:#7F7F7F;
          white-space: pre-line;
        }
        .hide {
          display: none;
        }
        .content-column img{
          margin: 0px 10px 0px 4px; height: 20px;
        }
        .text-display-sponsorship-name {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          margin: 0 0 0 10px !important;
          padding: 0 !important;
          color: #7F7F7F; 
          margin-right: 16px!important;
        }
        .reviewed-by-container p {
          color: #7F7F7F; 
          font-size: 16px; 
          font-weight: 400; 
          line-height: 20px; 
          margin-top: 30px;
        }
        .card-reference h6 {
          font-size: 14px; 
          font-weigth: 700; 
          line-height: 20px;
          margin: 0;
        }
        .card-reference img {
          height: 10px;
        }
        .content-button {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          padding-top: 2px;
          height: 0;
        }
        .btn-primary {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 12px 6px;
          background: #3570d2;
          border-radius: 8px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          text-align: center;
          color: #ffffff;
          width: 220px;
          cursor: pointer;
        }
        .btn-outline-primary {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 12px 6px;
          border: 1px solid #3570d2;
          border-radius: 8px;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          text-align: center;
          color: #3570d2;
          margin-right: 40px;
          width: 220px;
          cursor: pointer;
        }
        .disclaimer-header hr {
          border: 0;
          height: 0;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
          margin: 10px 0 10px 0;
        }
        .empty-space {
          height: 20px;
        }
        .container-main-not-login {
          display: flex !important;
          align-items: center;
          flex-direction: column;
          margin-top: 70px;
        }
        .container-main-not-login h1 {
          font-size: 16px;
          font-weight: 600;
          line-height: 21.6px;
          color: #424242;
        }
        .container-main-not-login p {
          font-size: 14px;
          font-weight: 400;
          line-height: 19px;
          color: #7F7F7F;
        }
        .btn-login {
          line-height: 44px;
          border: 1px solid #3570D2;
          border-radius: 5px;
          justify-content: center;
          display: flex;
          background-color: #3570D2;
          font-size: 18px;
          color: white;
          cursor: pointer;
          font-weight: 700;
          width: 320px;
          margin: 10px 0;
        }
        .disclaimer-content {
          max-height: 340px;
          overflow: scroll; 
          margin-bottom: 30px;
          padding-right: 15px;
        }
        .card-passed-post-test {
          display: flex;
          background: #D2FFEA;
          border: 1px solid #007C41;
          padding: 0;
          border-radius: 4px;
          width: 288px;
        }
        .card-passed-post-test p {
          color: #424242;
          font-size: 16px;
          line-height: 24px;
          font-weight: 400px;
          text-align: left;
          margin: 10px 0;
        }
        .card-passed-post-test img {
          padding: 0 4px 0 5px;
          margin-bottom: 28px;
        }
        .content-skp-row {
          display: flex;
          margin-top: 5px;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
        }
        .content-skp-row img {
          width: 20px;
          height: 20px;
          margin: 4px 4px 4px 0;
        }
        .text-skp-point {
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #f5a623;
          margin-right: 16px;
        }
        .text-skp-point img {
          height: 20px;
          width: 20px;
          margin-right: 4px;
        }
        .text-alo-point {
          display: flex;
          align-items: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #3570d2;
        }
        .text-alo-point img {
          height: 20px;
          width: 20px;
          margin-right: 4px;
        }
        .skp-webinar-content hr {
          border: 0;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
        }
        .text-display-webinar {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          margin: 10px 0 0 !important;
          padding: 0 !important;
          color: #7F7F7F;
        }
        .content-skp-row-point {
          display: flex;
          margin-top: 5px;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
        }
        .video-player {
          margin-top: 15px;
        }
        .container-publish-date {
          margin-top: 16px;
          margin-bottom: 16px;
        }
        .container-publish-date h3 {
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
          margin: 0 0 8px 0;
        }
        .html-publish-date {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #424242;
        }
      </style>
      <div class="container">
        <template is="dom-if" if="[[isLogin]]">
          <div class="container-main">
            <div class="content-main-left">
              <template is="dom-if" if="[[_checkSkpTypeOf(skp)]]">
                <div class="row">
                  <h3 class="text-display1">MODUL [[skp.module.order]]</h3>
                </div>
                <div class="content-text">
                  <h1 class="text-description">
                    [[skp.title]]
                  </h1>
                  <div class="content-column">
                    <label>
                      <img src="[[iconTimeBlack]]"/>
                      <h1 class="text-display2">
                        Durasi Belajar: [[skp.module.video_duration]]
                      </h1>
                    </label>
                  </div>
                  <div>
                    <template is="dom-if" if="{{_isVideoUrlAttached(skp)}}">
                      <video-player
                        url-video="{{skp.video_url}}"
                        on-tracking-progress-recording="_handleTrackingRecording"
                        on-player="_handleListenerPlayer"
                        id="ecourse-video-player">
                      </video-player>
                    </template>
                  </div>
                  <hr/>
                  <template is="dom-if" if="{{_isShowSponsoreChannel(skp)}}">
                    <div class="content-column-sponsorship">
                      <label>
                        <img src="[[_sponsoreChannelLogo(skp)]]"/>
                        <div>
                          <h1 class="text-display-sponsorship">[[_sponsoreChannelCategory(skp)]]</h1>
                          <h1 class="text-display-sponsorship-name">
                            [[_sponsoreChannelName(skp)]]
                          </h1>
                        </div>
                      </label>
                    </div>
                  </template>
                  <hr/>
                  <p inner-h-t-m-l="[[skp.content]]"></p>
                  <template is="dom-if" if="[[_isShowReviewedBy(skp)]]">
                    <div class="reviewed-by-container">
                      <p> Ditinjau oleh: [[skp.reviewed_by]]</p>
                    </div>
                  </template>
                  <template is="dom-if" if="[[!_checkSkpTypeOf(skp)]]">
                    <div class="container-publish-date">
                      <h3>Tanggal Tayang</h3>
                      <div class="html-publish-date">{{skp.published_date}}</div>
                    </div>
                  </template>
                  <template is="dom-if" if="[[_isShowReference(skp)]]">
                    <div class="container-reference">
                      <div class="card-reference" on-click="handleCollapse">
                        <h6>Referensi</h6>
                        <template is="dom-if" if="[[_iconReferenceShow(collapse)]]">
                          <img src="[[iconCaretDownBlack]]"/>
                        </template>
                        <template is="dom-if" if="[[_iconReferenceHide(collapse)]]">
                          <img src="[[iconCaretUpBlack]]"/>
                        </template>
                      </div>
                      <div class$="[[collapse]]">
                        [[skp.reference]]
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <template is="dom-if" if="[[!_checkSkpTypeOf(skp)]]">
                <div class="content-text">
                  <h1 class="text-description">
                    [[skp.title]]
                  </h1>
                  <div class="skp-webinar-content">
                    <label>
                      <h1 class="text-display-webinar">[[iterateFieldListName(skp.field_list)]]</h1>
                    </label>
                    <div class="content-skp-row">
                      <img src="[[skp.doctor_organization.logo]]"/> [[skp.doctor_organization.name]] 
                      <template is="dom-if" if="{{_checkEmptyData(skp.expired_date)}}">
                        &nbsp| &nbsp
                        <img src="[[iconExpBlack]]"/> [[skp.expired_date]]
                      </template>
                    </div>
                    <div class="content-skp-row-point">
                      <template is="dom-if" if="{{_checkSkpPoint(skp.skp_point)}}">
                        <div class="text-skp-point">
                          <img src="[[iconSkpPoint]]"/> +[[formattedSkpPoint(skp.skp_point)]] SKP
                        </div>
                      </template>
                      <div class="text-alo-point">
                        <img src="[[iconAloPoint]]"/>+[[skp.alo_point]] AP
                      </div>
                    </div>
                    <template is="dom-if" if="{{_isVideoUrlAttached(skp)}}">
                      <div class="video-player">
                        <video-player
                          url-video="{{skp.video_url}}"
                          on-tracking-progress-recording="_handleTrackingRecording"
                          on-player="_handleListenerPlayer"
                          id="ecourse-video-player">
                        </video-player>
                      </div>
                    </template>
                    <hr/>
                  </div>
                  <template is="dom-if" if="{{_isShowSponsoreChannel(skp)}}">
                    <div class="content-column-sponsorship">
                      <label>
                        <img src="[[_sponsoreChannelLogo(skp)]]"/>
                        <div>
                          <h1 class="text-display-sponsorship">[[_sponsoreChannelCategory(skp)]]</h1>
                          <h1 class="text-display-sponsorship-name">
                            [[_sponsoreChannelName(skp)]]
                          </h1>
                        </div>
                      </label>
                    </div>
                  </template>
                  <hr/>
                  <p inner-h-t-m-l="[[skp.content]]"></p>
                  <template is="dom-if" if="[[_isShowReviewedBy(skp)]]">
                    <div class="reviewed-by-container">
                      <p> Ditinjau oleh: [[skp.reviewed_by]]</p>
                    </div>
                  </template>
                  <template is="dom-if" if="[[!_checkSkpTypeOf(skp)]]">
                    <div class="container-publish-date">
                      <h3>Tanggal Tayang</h3>
                      <div class="html-publish-date">{{skp.published_date}}</div>
                    </div>
                  </template>
                  <template is="dom-if" if="[[_isShowReference(skp)]]">
                    <div class="container-reference">
                      <div class="card-reference" on-click="handleCollapse">
                        <h6>Referensi</h6>
                        <template is="dom-if" if="[[_iconReferenceShow(collapse)]]">
                          <img src="[[iconCaretDownBlack]]"/>
                        </template>
                        <template is="dom-if" if="[[_iconReferenceHide(collapse)]]">
                          <img src="[[iconCaretUpBlack]]"/>
                        </template>
                      </div>
                      <div class$="[[collapse]]">
                        [[skp.reference]]
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <div class="content-main-right">
              <template is="dom-if" if="[[!_checkIsUserPassedPostTest(skp)]]">
                <div class="card-menu">
                  <template is="dom-if" if="[[_isSkpDetailExpired(skp)]]">
                    <div class="btn btn-start-test-expired">
                      {{_textButtonSkpDetail(skp.status)}}
                    </div>
                  </template>
                  <template is="dom-if" if="[[!_isSkpDetailExpired(skp)]]">
                    <div class="btn btn-start-test" on-click="activateDisclaimerBtmSheet">
                      {{_textButtonSkpDetail(skp.status)}}
                    </div>
                  </template>
                </div>
              </template>
              <template is="dom-if" if="[[_checkIsUserPassedPostTest(skp)]]">
                <div class="card-menu">
                  <button class="btn card-passed-post-test">
                    <img src="[[iconChecklistGreen]]"/>
                    <p>Anda sudah berhasil menjawab tes CME ini.</p>
                  </button>
                </div>
              </template>
            </div>
            <modal-container id="modal-disclaimer" title="[[disclaimer.title]]" width="25%" margin="3.3%">
              <div class="disclaimer-header" slot="child-component"><hr/></div>
              <div slot="child-component"> 
                <p class="disclaimer-content" inner-h-t-m-l="[[disclaimer.content]]"></p>
              </div>
              <div class="content-button" slot="child-component">
                <div class="btn-outline-primary" on-click="deactivateDisclaimerBtmSheet">Tidak</div>
                <div class="btn-primary" on-click="navigatePostTestScreen">Setuju</div>
              </div>
            </modal-container>
          </div>
        </template>
        <template is="dom-if" if="[[!_checkIsUserPassedPostTest(skp)]]">
          <template is="dom-if" if="[[_checkSkpTypeOf(skp)]]">
            <general-toast
              is-active="[[isShowToast]]"
              body="E-Course sudah kadaluarsa, Anda tidak dapat melakukan Post Test lagi."
              color="red">
            </general-toast>
          </template>
          <template is="dom-if" if="[[!_checkSkpTypeOf(skp)]]">
            <general-toast
              is-active="[[isShowToast]]"  
              body="CME sudah kadaluarsa, Anda tidak dapat melakukan Post Test lagi."
              color="red">
            </general-toast>
          </template>
        </template>
        <template is="dom-if" if="[[!isLogin]]">
          <div class="container-main-not-login">
            <h1>Membutuhkan Akses Ke Dalam Akun</h1>
            <p>Silakan masuk atau daftar untuk dapat mengakses halaman ini.</p>
            <button
              class="btn-login"
              on-click="_activateLoginPopup">
                Masuk atau Daftar Alomedika
            </button>
          </div>
        </template>
      </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number
      },
      skp: {
        type: Object
      },
      accessibility: {
        type: Object
      },
      disclaimer: {
        type: Object
      },
      iconTimeBlack: {
        type: String,
        value: iconTimeBlack
      },
      modalConnect: {
        type: Boolean,
        value: false
      },
      modalDisconnect: {
        type: Boolean,
        value: false
      },
      iconCaretDownBlack: {
        type: String,
        value: iconCaretDownBlack
      },
      iconCaretUpBlack: {
        type: String,
        value: iconCaretUpBlack
      },
      iconChecklistGreen: {
        type: String,
        value: iconChecklistGreen
      },
      iconExpBlack: {
        type: String,
        value: iconExpBlack
      },
      iconSkpPoint: {
        type: String,
        value: iconSkpPoint
      },
      iconAloPoint: {
        type: String,
        value: iconAloPoint
      },
      collapse: {
        type: String,
        value: "hide"
      },
      _checkIsUserPassedPostTest: {
        type: Function,
        value: () => _checkIsUserPassedPostTest
      },
      _sponsoreChannelLogo: {
        type: Function,
        value: () => _sponsoreChannelLogo
      },
      _sponsoreChannelCategory: {
        type: Function,
        value: () => _sponsoreChannelCategory
      },
      _sponsoreChannelName: {
        type: Function,
        value: () => _sponsoreChannelName
      },
      _isShowSponsoreChannel: {
        type: Function,
        value: () => _isShowSponsoreChannel
      },
      _iconReferenceShow: {
        type: Function,
        value: () => _iconReferenceShow
      },
      _iconReferenceHide: {
        type: Function,
        value: () => _iconReferenceHide
      },
      _isShowReference: {
        type: Function,
        value: () => _isShowReference
      },
      _isShowReviewedBy: {
        type: Function,
        value: () => _isShowReviewedBy
      },
      _checkSkpTypeOf: {
        type: Function,
        value: () => _checkSkpTypeOf
      },
      iterateFieldListName: {
        type: Function,
        value: () => iterateFieldListName
      },
      _isVideoUrlAttached: {
        type: Function,
        value: () => _isVideoUrlAttached
      },
      _isSkpDetailExpired: {
        type: Function,
        value: () => _isSkpDetailExpired
      },
      _textButtonSkpDetail: {
        type: Function,
        value: () => _textButtonSkpDetail
      },
      _sessionStorageSkp: {
        type: Function,
        value: () => _sessionStorageSkp
      },
      _checkSkpPoint: {
        type: Function,
        value: () => _checkSkpPoint
      },
      _checkEmptyData: {
        type: Function,
        value: () => _checkEmptyData
      },
      isShowToast: {
        type: Boolean,
        value: false
      },
      userUid: {
        type: String,
      },
      skpModuleOrder: {
        type: Number,
      },
      trackingVdStartGA4: {
        type: Boolean,
        value: true
      },
      formattedSkpPoint: {
        type: Function,
        value: () => General.formattedSkpPoint
      },
    };
  }

  ready() {
    super.ready();
    if (this.isLogin == 1 && General.getCookie("new_alomedika_logged_in") == undefined) {
      window.location.reload();
      this.isLogin = 0;
    }
    this.isShowToast = _isSkpDetailExpired(this.skp)
    afterNextRender(this, function() {
      this.sendGASkpModule(true);
      if (this.skp.type_of == "skp") {
        WebinarAnalytics.viewSkp(this.skp);
      } else {
        EcourseAnalytics.viewSkp(this.skp, this.accessibility);
      } 
    });
  }

  _handleListenerPlayer(e, data) {
    const vdType = this.skp.type_of == "skp" ? "skp" : "ecourse_module";
    if(data == "play") {
      if(this.trackingVdStartGA4) {
        VideoPlayerAnalytics.vdStart(this.skp, "skp", vdType);
        this.trackingVdStartGA4 = false;
      }
    } else if(data == "ended") {
      VideoPlayerAnalytics.vdFinished(this.skp, "skp", vdType);
    }
  }
  
  handleCollapse() {
    this.collapse = this.collapse == "show" ? "hide" : "show";
  }

  activateDisclaimerBtmSheet() {
    this.shadowRoot.querySelector("#modal-disclaimer").activate();
    this.sendGASkpModule(false);
  }

  deactivateDisclaimerBtmSheet() {
    this.shadowRoot.querySelector("#modal-disclaimer").deactivate();
  }

  navigatePostTestScreen() {
    this._sessionStorageSkp(this.skp);
    if (this.skp.type_of == "skp") {
      WebinarAnalytics.startTest(this.skp);
    } else {
      EcourseAnalytics.startTest(this.skp, this.accessibility);
    } 
    window.location = window.location.origin + `/skp/${this.skp.id}/question?t=${this.skp.title}`;
  }
  
  _activateLoginPopup() {
    $('#entrance-overlay').css("display", "block");
  }

  sendGASkpModule(isPageView) {
    if (_checkSkpTypeOf(this.skp)) {
      if (isPageView) {
        this.sendGAModuleView();
      } else {
        this.sendGAModuleClicked();
      }
    } else {
      if (isPageView) {
        this.sendGASkpView();
      } else {
        this.sendGASkpClicked();
      }
    }
  }

  getTrackingUserUid() {
    return this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
  }

  getModuleOrder () {
    return this.skp.module.order ? `| module_order: ${this.skp.module.order}` : "";
  }

  sendGASkpView() {
    const userUid = this.getTrackingUserUid();
    const sourceUrl = window.location.href;
    const moduleOrder = this.getModuleOrder();
    const skpCategory = this.iterateFieldListName(this.skp.field_list)
    const eventLabel = `${userUid}skp_id: ${this.skp.id} | skp_title: ${this.skp.title} | skp_category: ${skpCategory} | skp_type: skp | device_category: desktop | source url: ${sourceUrl} ${moduleOrder}`
    Alodokter.sendEventGA("skp detail page", "skp_detail_view", eventLabel);
  }

  sendGASkpClicked() {
    const userUid = this.getTrackingUserUid();
    const sourceUrl = window.location.href;
    const moduleOrder = this.getModuleOrder();
    const skpCategory = this.iterateFieldListName(this.skp.field_list)
    const eventLabel = `${userUid}skp_id: ${this.skp.id} | skp_title: ${this.skp.title} | skp_category: ${skpCategory} | skp_type: skp | device_category: desktop | source url: ${sourceUrl} ${moduleOrder}`
    Alodokter.sendEventGA("skp detail page", "skp_start_test", eventLabel);
  }

  sendGAModuleView() {
    const userUid = this.getTrackingUserUid();
    const sourceUrl = window.location.href;
    const moduleOrder = this.getModuleOrder();
    const eventLabel = `${userUid}skp_id: ${this.skp.id} | skp_title: ${this.skp.title} | device_category: desktop | source url: ${sourceUrl} ${moduleOrder}`
    Alodokter.sendEventGA("ecourse module page", "ecourse_module_view", eventLabel);
  }

  sendGAModuleClicked() {
    const userUid = this.getTrackingUserUid();
    const sourceUrl = window.location.href;
    const moduleOrder = this.getModuleOrder();
    const eventLabel = `${userUid}skp_id: ${this.skp.id} | skp_title: ${this.skp.title} | device_category: desktop | source url: ${sourceUrl} ${moduleOrder}`
    Alodokter.sendEventGA("ecourse module page", "ecourse_start_test", eventLabel);
  }

  _handleTrackingRecording(e, data) {
    const vdType = this.skp.type_of == "skp" ? "skp" : "ecourse_module";
    VideoPlayerAnalytics.vdProgress(this.detail, "skp", vdType, data);
  }
}

customElements.define("skp-show", SkpShow);
